import { apiRequest } from './api'

export function listMatters() {
  return apiRequest('/matters/list', {
    method: 'POST',
  })
}

export function createMatter(payload) {
  return apiRequest('/matters/create', {
    method: 'POST',
    body: JSON.stringify(payload),
  })
}

export function updateMatter(payload) {
  return apiRequest('/matters/update', {
    method: 'POST',
    body: JSON.stringify(payload),
  })
}

export function deleteMatter(matterId) {
  return apiRequest('/matters/delete', {
    method: 'POST',
    body: JSON.stringify({ matterId }),
  })
}
